import { useNavigate } from "react-router-dom";

import { crudRoutes } from "../../../../../../router/routesConstants";

import { useAppDispatch } from "../../../../../../redux/hooks";
import { FleetFeatureDocumentsDataInterface } from "../../../../../../redux/interfaces/fleet.interface";
import { setFleetFeatureDocumentData } from "../../../../../../redux/reducer/fleet.reducer";
import { fetchDeleteFeatureDocument } from "../../../../../../redux/api/fleet.api";

import ActionMenu, {
  ActionMenuItem,
} from "../../../../../../components/actionMenu/ActionMenu";
import useRoutesHelper from "../../../../../../hooks/useRoutesHelper";
import usePermissions from "../../../../../../router/usePermissions";
import userRoles from "../../../../../../constants/userRoles";
import { getCurrentDate } from "../../../../../../utils/dateAndTime";

function FleetFeatureDocumentsActionButton({
  crudData,
  itemId,
}: {
  itemId: string;
  crudData: FleetFeatureDocumentsDataInterface;
  tableContext: any;
}) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const { isAuthorized } = usePermissions();
  const { routeMainParam } = useRoutesHelper();
  const { routeParams } = useRoutesHelper();

  const { featureId } = routeMainParam as { featureId: string | number };
  const { nrauto } = routeParams as {
    nrauto: string;
  };

  const {
    CAR_FEATURE_DOCUMENT_DELETE_PERMISSION,
    CAR_FEATURE_DOCUMENT_EDIT_PERMISSION,
  } = {
    CAR_FEATURE_DOCUMENT_EDIT_PERMISSION: isAuthorized(
      userRoles.CAR_FEATURE_DOCUMENT_EDIT,
    ),
    CAR_FEATURE_DOCUMENT_DELETE_PERMISSION: isAuthorized(
      userRoles.CAR_FEATURE_DOCUMENT_DELETE,
    ),
  };

  const handleEdit = () => {
    if (!CAR_FEATURE_DOCUMENT_EDIT_PERMISSION || invalidDocument) return;
    dispatch(setFleetFeatureDocumentData(crudData));
    navigate(`${itemId}/${crudRoutes.edit}?nrauto=${nrauto}`);
  };

  const handleDelete = () => {
    if (!CAR_FEATURE_DOCUMENT_DELETE_PERMISSION || invalidDocument) return;
    dispatch(fetchDeleteFeatureDocument({ id: itemId, featureId: featureId }));
  };

  const currentDate = getCurrentDate();
  const invalidDocument = crudData.doc_ts_stop < currentDate;

  const items: ActionMenuItem[] = [
    {
      id: "edit",
      label: "Editeaza detalii document",
      section: "manage",
      icon: "EDIT",
      tooltip: invalidDocument
        ? "Documentul a expirat si nu mai poate fi editat."
        : "Deschide editarea detaliilor documentului.",
      hidden: !CAR_FEATURE_DOCUMENT_EDIT_PERMISSION,
      disabled: invalidDocument,
      onClick: handleEdit,
    },
    {
      id: "delete",
      label: "Sterge documentul",
      section: "danger",
      icon: "DELETE",
      color: "error",
      tooltip: invalidDocument
        ? "Documentul a expirat si nu mai poate fi sters."
        : "Sterge documentul dupa confirmare.",
      hidden: !CAR_FEATURE_DOCUMENT_DELETE_PERMISSION,
      disabled: invalidDocument,
      withConfirmationModal: {
        modalTitle: "Doriti sa stergeti acest document?",
        modalLeftButtonColor: "inherit",
        modalRightButtonOnClick: handleDelete,
        modalRightButtonText: "Sterge",
        modalRightButtonColor: "error",
        modalLeftButtonText: "Anuleaza",
      },
    },
  ];

  return (
    <ActionMenu
      items={items}
      minItemsForMenu={2}
      title={nrauto}
      ariaLabel={`Actiuni pentru documentul echipamentului masinii ${nrauto}`}
    />
  );
}

export default FleetFeatureDocumentsActionButton;
